import React, { useContext, useEffect } from "react";
import { Container } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import FormContext from "../context/FormContext";
import useGetPrice from "../hooks/useGetPrice";

import Styles from "../styles.module.scss";

export const FourForm: () => JSX.Element = () => {
  const history = useHistory();
  const { formData } = useContext(FormContext);
  const { lastPrice, tempPrice, percentage } = useGetPrice();

  useEffect(() => {
    if (!formData?.projectName) {
      history.push("/example/forms-challenge/");
    }
  }, [formData]);

  return (
    <Container className={Styles.mainContainer}>
      <div>
        <h5>Datos ingresados: </h5>
      </div>

      <div>
        <p className='font-weight-bold mb-2'>Informacion del General:</p>
        <p> Nombre del proyecto: {formData?.projectName} </p>
        <p className={Styles.altP}>
          Descripcion: {formData?.projectDescription}
        </p>
        <p className='mt-1'>
          Tipo de proyecto:{" "}
          {formData?.projectIsNew === "Yes" ? "Nuevo" : "Ya existente"}
        </p>
        <p>
          Nivel de importancia:{" "}
          {formData?.projectLevel === "High"
            ? "Alto"
            : formData?.projectLevel === "Medium"
            ? "Medio"
            : "Bajo"}
        </p>
      </div>

      <hr />

      <div>
        <p className='font-weight-bold mb-2'>Informacion del Tecnica: </p>
        <p> Horas a trabajar: {formData?.projectTime} horas </p>
        <p>Tecnologias a utilizar: </p>
        {formData?.projectTechs && (
          <ul className='ml-4 mt-2'>
            {formData?.projectTechs.map((tech: string, index: number) => (
              <li key={index}>{tech}</li>
            ))}
          </ul>
        )}
      </div>

      <hr />

      <div>
        <p className='font-weight-bold mb-2'>Informacion de Localidad: </p>
        <p> Pais: {formData?.clientCountry}</p>
        <p> Ciudad: {formData?.clientCity}</p>
        <p> Codigo postal: {formData?.clientZip}</p>
      </div>

      <hr />

      <div>
        <p className='font-weight-bold mb-2'>Informacion Financiera: </p>
        <p> Precio por horas: ${tempPrice}</p>
        <p> Valor tecnologias: ${percentage}</p>
        <p className='mt-3 '> Precio final: ${lastPrice.toFixed(1)}</p>
      </div>
    </Container>
  );
};
